module.exports = __webpack_public_path__ + "img/al.070c7840.svg";